import Grid from '@mui/material/Unstable_Grid2';
import {Button, Link, Skeleton, useMediaQuery} from '@mui/material';
import { AsyncImage } from 'loadable-image';

import Facebook from './Facebook';
import Instagram from './Instagram';

export default function Home() {
  const mobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return (
  <>   
    <div style={{position:'absolute', width:'100%', top:'8px', zIndex:999}}>
      {mobile?
      <></>
      :
      <p style={{ letterSpacing:'clamp(0px, 1.3vw, 1.3rem)',
        fontSize:'clamp(0.4rem, 1.2vw, 1.2rem)', fontWeight:'400', padding:'0px', textAlignLast:'center', color:'#fff', width:'99%', margin:'auto'
      }}>
      SCOPRI UNA SELEZIONE DI OLTRE 100 PREMIUM BRAND
      </p>
      }
    </div> 
    <Grid container rowSpacing={0.2} columnSpacing={0.2} disableEqualOverflow sx={{height:'100%'}}>
      <Grid xs={12} sm={12} display="flex" justifyContent="center" alignItems="center">
        <div style={{position:'relative', width:'100%', height:'100%', backgroundColor:'#fff'}}>
          <Link href='https://www.imatra.com/shop' sx={{textDecoration:'none'}}>            
            <AsyncImage
              loader={<Skeleton variant="rectangular" width={'100%'} height={'100%'} />} 
              src={mobile?'/images/mobile/home.jpg':'/images/home.jpg'}
              alt={'nob 4.0'}
              error={<img src="/images/placeholder.png" alt="nob 4.0" style={{width: "100%", height: "100%", aspectRatio: mobile? 0.8:1.6}}/>}
              style={{width: "100%", height: "100%", aspectRatio: mobile?0.8:1.6, objectFit:'cover', opacity:mobile?1:1}}
            />
            <div style={{display:mobile?'block':'none', position:'absolute', bottom:'2rem', color:'#fff', width:'100%', textAlign:'center',letterSpacing:'0.2rem', fontSize:'0.85rem'}}>
              <p>SCOPRI UNA SELEZIONE</p>
              <p>DI OLTRE 100 PREMIUM BRAND</p>
            </div>
          </Link>
        </div>
      </Grid>
      <Grid xs={12} sm={12} display="flex" justifyContent="center" alignItems="center">
        <div style={{position:'relative', width:'100%', height:'100%', padding:'4rem 2rem'}}>
          <div style={{display:'flex', justifyContent:'space-around', alignItems:'center', flexDirection: mobile ? 'column' : 'row', rowGap:'2rem'}}>
            <div style={{fontSize:'clamp(1rem,1.7vw,1.5rem)', lineHeight:'1.4', color:'#000'}}>
              <p style={{ fontWeight:'bold'}}>Vuoi guadagnare pedalando?</p>                
              <p>Scarica Imatra, l’app che trasforma ogni tua pedalata in un guadagno.</p>                
              <p>Inizia subito a produrre Imatra Coin da spendere sul nostro shop</p>                
            </div>
            <div>
              <div style={{display:'flex', justifyContent:'space-around', alignItems:'center', columnGap:'1rem'}}>
                <a href="https://apps.apple.com/it/app/imatra/id1518809065" title="imatra on apple store" style={{display:'contents'}}>
                  <img src={`/images/apple-store.png`} alt="imatra" style={{width:'120px'}} />
                </a>     
                <a href="https://play.google.com/store/apps/details?id=com.imatra.app" title="imatra on google play" style={{display:'contents'}}>     
                  <img src={`/images/google-play.png`} alt="imatra" style={{width:'120px'}} />        
                </a>
              </div>
            </div>
          </div>
        </div>
      </Grid>
      <Grid xs={12} sm={6} display="flex" justifyContent="center" alignItems="center">
          <div style={{position:'relative', width:'100%', height:'100%'}}>
            <Link href='https://www.imatra.com/brand/maap' sx={{textDecoration:'none'}}>
              <AsyncImage
                loader={<Skeleton variant="rectangular" width={'100%'} height={'100%'} />} 
                src={'/images/maap.jpg'}
                alt={'nob 4.0'}
                error={<img src="/images/placeholder.png" alt="nob 4.0" style={{width: "100%", height: "100%", aspectRatio: 0.8}}/>}
                style={{width: "100%", height: "100%", aspectRatio: 0.8, objectFit:'cover'}}
              />
              <div style={{position:'absolute', bottom:'clamp(2rem, 3.125vw, 2.5rem)', left:'clamp(2rem, 3.125vw, 2.5rem)', color:'#fff'}}>              
                <p style={{fontSize:'clamp(1.65rem, 3vw, 2.3rem)', fontWeight:'700', margin:'0px 0px 24px 0px', padding:'0px', lineHeight: '0.7'}}>{'MAAP'}</p>                          
                <Button sx={{border:'solid 1px #fff', borderColor:'#fff', color:'#fff', borderRadius:'0px'}}>
                  <span style={{fontSize:'clamp(0.7rem, 1.1vw, 0.87rem)'}}>{'SHOP NOW'}</span>
                </Button>                            
              </div>            
            </Link>
          </div>
        </Grid>
        <Grid xs={12} sm={6} display="flex" justifyContent="center" alignItems="center">
          <div style={{position:'relative', width:'100%', height:'100%'}}>
            <Link href='https://www.imatra.com/brand/pas-normal-studios' sx={{textDecoration:'none'}}>
              <AsyncImage
                loader={<Skeleton variant="rectangular" width={'100%'} height={'100%'} />} 
                src={'/images/pns.jpg'}
                alt={'nob 4.0'}
                error={<img src="/images/placeholder.png" alt="nob 4.0" style={{width: "100%", height: "100%", aspectRatio: 0.8}}/>}
                style={{width: "100%", height: "100%", aspectRatio: 0.8, objectFit:'cover'}}
              />              
              <div style={{position:'absolute', bottom:'clamp(2rem, 3.125vw, 2.5rem)', left:'clamp(2rem, 3.125vw, 2.5rem)', color:'#fff'}}>              
                <p style={{fontSize:'clamp(1.65rem, 3vw, 2.3rem)', fontWeight:'700', margin:'0px 0px 24px 0px', padding:'0px', lineHeight: '0.7'}}>{'PAS NORMAL STUDIOS'}</p>                          
                <Button sx={{border:'solid 1px #fff', borderColor:'#fff', color:'#fff', borderRadius:'0px'}}>
                  <span style={{fontSize:'clamp(0.7rem, 1.1vw, 0.87rem)'}}>{'SHOP NOW'}</span>
                </Button>              
              </div>            
            </Link>
          </div>
        </Grid>      
        <Grid xs={12} sm={6} display="flex" justifyContent="center" alignItems="center">
          <div style={{position:'relative', width:'100%', height:'100%'}}>
            <Link href='https://www.imatra.com/brand/pissei' sx={{textDecoration:'none'}}>
              <AsyncImage
                loader={<Skeleton variant="rectangular" width={'100%'} height={'100%'} />} 
                src={'/images/pissei.jpg'}
                alt={'nob 4.0'}
                error={<img src="/images/placeholder.png" alt="nob 4.0" style={{width: "100%", height: "100%", aspectRatio: 0.8}}/>}
                style={{width: "100%", height: "100%", aspectRatio: 0.8, objectFit:'cover'}}
              />              
              <div style={{position:'absolute', bottom:'clamp(2rem, 3.125vw, 2.5rem)', left:'clamp(2rem, 3.125vw, 2.5rem)', color:'#fff'}}>              
                <p style={{fontSize:'clamp(1.65rem, 3vw, 2.3rem)', fontWeight:'700', margin:'0px 0px 24px 0px', padding:'0px', lineHeight: '0.7'}}>{'PISSEI'}</p>                          
                <Button sx={{border:'solid 1px #fff', borderColor:'#fff', color:'#fff', borderRadius:'0px'}}>
                  <span style={{fontSize:'clamp(0.7rem, 1.1vw, 0.87rem)'}}>{'SHOP NOW'}</span>
                </Button>              
              </div>            
            </Link>
          </div>
        </Grid>
        <Grid xs={12} sm={6} display="flex" justifyContent="center" alignItems="center">
          <div style={{position:'relative', width:'100%', height:'100%'}}>
            <Link href='https://www.imatra.com/brand/cafe-du-cycliste' sx={{textDecoration:'none'}}>
              <AsyncImage
                loader={<Skeleton variant="rectangular" width={'100%'} height={'100%'} />} 
                src={'/images/cdc.jpg'}
                alt={'nob 4.0'}
                error={<img src="/images/placeholder.png" alt="nob 4.0" style={{width: "100%", height: "100%", aspectRatio: 0.8}}/>}
                style={{width: "100%", height: "100%", aspectRatio: 0.8, objectFit:'cover'}}
              />              
              <div style={{position:'absolute', bottom:'clamp(2rem, 3.125vw, 2.5rem)', left:'clamp(2rem, 3.125vw, 2.5rem)', color:'#fff'}}>              
                <p style={{fontSize:'clamp(1.65rem, 3vw, 2.3rem)', fontWeight:'700', margin:'0px 0px 24px 0px', padding:'0px', lineHeight: '0.7'}}>{'CAFÉ DU CYCLISTE'}</p>                          
                <Button sx={{border:'solid 1px #fff', borderColor:'#fff', color:'#fff', borderRadius:'0px'}}>
                  <span style={{fontSize:'clamp(0.7rem, 1.1vw, 0.87rem)'}}>{'SHOP NOW'}</span>
                </Button>              
              </div>            
            </Link>
          </div>
        </Grid>
        <Grid xs={12} sm={6} display="flex" justifyContent="center" alignItems="center">
          <div style={{position:'relative', width:'100%', height:'100%'}}>
            <Link href='https://www.imatra.com/brand/assos' sx={{textDecoration:'none'}}>
              <AsyncImage
                loader={<Skeleton variant="rectangular" width={'100%'} height={'100%'} />} 
                src={'/images/assos.jpg'}
                alt={'nob 4.0'}
                error={<img src="/images/placeholder.png" alt="nob 4.0" style={{width: "100%", height: "100%", aspectRatio: 0.8}}/>}
                style={{width: "100%", height: "100%", aspectRatio: 0.8, objectFit:'cover'}}
              />              
              <div style={{position:'absolute', bottom:'clamp(2rem, 3.125vw, 2.5rem)', left:'clamp(2rem, 3.125vw, 2.5rem)', color:'#fff'}}>              
                <p style={{fontSize:'clamp(1.65rem, 3vw, 2.3rem)', fontWeight:'700', margin:'0px 0px 24px 0px', padding:'0px', lineHeight: '0.7'}}>{'ASSOS'}</p>                          
                <Button sx={{border:'solid 1px #fff', borderColor:'#fff', color:'#fff', borderRadius:'0px'}}>
                  <span style={{fontSize:'clamp(0.7rem, 1.1vw, 0.87rem)'}}>{'SHOP NOW'}</span>
                </Button>              
              </div>            
            </Link>
          </div>
        </Grid>
        <Grid xs={12} sm={6} display="flex" justifyContent="center" alignItems="center">
          <div style={{position:'relative', width:'100%', height:'100%'}}>
            <Link href='https://www.imatra.com/brand/kask' sx={{textDecoration:'none'}}>
              <AsyncImage
                loader={<Skeleton variant="rectangular" width={'100%'} height={'100%'} />} 
                src={'/images/kask.jpg'}
                alt={'nob 4.0'}
                error={<img src="/images/placeholder.png" alt="nob 4.0" style={{width: "100%", height: "100%", aspectRatio: 0.8}}/>}
                style={{width: "100%", height: "100%", aspectRatio: 0.8, objectFit:'cover'}}
              />              
              <div style={{position:'absolute', bottom:'clamp(2rem, 3.125vw, 2.5rem)', left:'clamp(2rem, 3.125vw, 2.5rem)', color:'#fff'}}>              
                <p style={{fontSize:'clamp(1.65rem, 3vw, 2.3rem)', fontWeight:'700', margin:'0px 0px 24px 0px', padding:'0px', lineHeight: '0.7'}}>{'KASK'}</p>                          
                <Button sx={{border:'solid 1px #fff', borderColor:'#fff', color:'#fff', borderRadius:'0px'}}>
                  <span style={{fontSize:'clamp(0.7rem, 1.1vw, 0.87rem)'}}>{'SHOP NOW'}</span>
                </Button>              
              </div>            
            </Link>
          </div>
        </Grid>

      <Grid xs={12} sm={12} display="flex" justifyContent="center" alignItems="center">
        <div style={{position:'relative', width:'100%', height:'100%', padding:mobile?'4rem 2rem 0 2rem':'6rem 2rem 1rem 2rem'}}>
          <div style={{display:'flex', justifyContent:'space-around', alignItems:'center'}}>
            <div style={{fontSize:'clamp(1.8rem,2.7vw,2.5rem)', lineHeight:'1.4', color:'#000'}}>
              <p style={{ fontWeight:'bold'}}>I nostri store</p>   
              <p style={{fontSize:'clamp(1rem,1.7vw,1.5rem)', visibility:'hidden'}}>
                Scarica Imatra, l’app che trasforma ogni tua pedalata in un guadagno. Guadagna pedalando!
              </p>                             
            </div>
            <div><p>&nbsp;</p></div>
          </div>
        </div>
      </Grid>

        <Grid xs={12} sm={4} display="flex" justifyContent="center" alignItems="center" sx={{paddingRight:mobile?'0px':'8px',paddingBottom:mobile?'8px':'0px'}}>
          <div style={{position:'relative', width:'100%', height:'100%'}}>
            <Link href='https://www.imatra.com/shop' sx={{textDecoration:'none'}}>
              <AsyncImage
                loader={<Skeleton variant="rectangular" width={'100%'} height={'100%'} />} 
                src={'/images/rimini.jpg'}
                alt={'nob 4.0'}
                error={<img src="/images/placeholder.png" alt="nob 4.0" style={{width: "100%", height: "100%", aspectRatio: 0.8}}/>}
                style={{width: "100%", height: "100%", aspectRatio: 0.8, objectFit:'cover'}}
              />              
              <div style={{position:'absolute', bottom:'clamp(2rem, 3.125vw, 2.5rem)', width:'100%', textAlign:'center', color:'#fff'}}>              
                <p style={{fontSize:'clamp(1.65rem, 3vw, 2.3rem)', fontWeight:'700', margin:'0px 0px 24px 0px', padding:'0px', lineHeight: '0.7'}}>
                  {'RIMINI'}
                </p>
                <div style={{fontSize:'clamp(0.7rem, 1.1vw, 0.87rem)'}}>
                  <p>Via Circonvallazione Occidentale, 112</p>                          
                  <p>Tel. 0541 1733071</p>
                </div>
              </div>            
            </Link>
          </div>
        </Grid>
        <Grid xs={12} sm={4} display="flex" justifyContent="center" alignItems="center">
          <div style={{position:'relative', width:'100%', height:'100%', backgroundColor:'#000'}}>
            <Link href='https://www.imatra.com/shop' sx={{textDecoration:'none'}}>
              <AsyncImage
                loader={<Skeleton variant="rectangular" width={'100%'} height={'100%'} />} 
                src={'/images/san-mauro.jpg'}
                alt={'nob 4.0'}
                error={<img src="/images/placeholder.png" alt="nob 4.0" style={{width: "100%", height: "100%", aspectRatio: 0.8}}/>}
                style={{width: "100%", height: "100%", aspectRatio: 0.8, objectFit:'cover', opacity:0.75}}
              />              
              <div style={{position:'absolute', bottom:'clamp(2rem, 3.125vw, 2.5rem)', width:'100%', textAlign:'center', color:'#fff'}}>              
                <p style={{fontSize:'clamp(1.65rem, 3vw, 2.3rem)', fontWeight:'700', margin:'0px 0px 24px 0px', padding:'0px', lineHeight: '0.7'}}>
                  {'SAN MAURO PASCOLI'}
                </p>
                <div style={{fontSize:'clamp(0.7rem, 1.1vw, 0.87rem)'}}>
                  <p>Via Bellaria Nuova, 514</p>                          
                  <p>Tel. 0541 933413</p>
                </div>
              </div>            
            </Link>
          </div>
        </Grid>
        <Grid xs={12} sm={4} display="flex" justifyContent="center" alignItems="center" sx={{paddingLeft:mobile?'0px':'8px',paddingTop:mobile?'8px':'0px'}}>
          <div style={{position:'relative', width:'100%', height:'100%'}}>
            <Link href='https://www.imatra.com/shop' sx={{textDecoration:'none'}}>
              <AsyncImage
                loader={<Skeleton variant="rectangular" width={'100%'} height={'100%'} />} 
                src={'/images/cesenatico.jpg'}
                alt={'nob 4.0'}
                error={<img src="/images/placeholder.png" alt="nob 4.0" style={{width: "100%", height: "100%", aspectRatio: 0.8}}/>}
                style={{width: "100%", height: "100%", aspectRatio: 0.8, objectFit:'cover'}}
              />              
              <div style={{position:'absolute', bottom:'clamp(2rem, 3.125vw, 2.5rem)', width:'100%', textAlign:'center', color:'#fff'}}>              
                <p style={{fontSize:'clamp(1.65rem, 3vw, 2.3rem)', fontWeight:'700', margin:'0px 0px 24px 0px', padding:'0px', lineHeight: '0.7'}}>
                  {'CESENATICO'}
                </p>
                <div style={{fontSize:'clamp(0.7rem, 1.1vw, 0.87rem)'}}>
                  <p>Ss Adriatica, 16</p>                          
                  <p>Tel. 0547 673499</p>
                </div>
              </div>            
            </Link>
          </div>
        </Grid>

        <Grid xs={12} sm={12} display="flex" justifyContent="center" alignItems="center">
          <div style={{position:'relative', width:'100%', height:'100%'}}>
            <div style={{position:'relative', fontSize:'0.7rem', color:'#000', margin:'auto'}}>                
                <div style={{width:'100%', textAlign:'center', paddingTop:'35px', display:'flex', justifyContent:'center', alignItems:'center'}}>
                  <Facebook to="https://www.facebook.com/notonlybike"/>
                  <Instagram to="https://www.instagram.com/notonlybike/" />
                </div>
                {mobile?
                  <div style={{width:'100%', textAlign:'center', paddingBottom:'35px', fontSize:'clamp(0.7rem, 1vw, 1rem)'}}>
                    <p>NOB 4.0 S.r.l. - Società Benefit. &copy; Copyright 2023</p>
                    <p>Sede in Via Appiani 12 - 20121 Milano - P.I. 04545490403</p>
                  </div>
                :
                  <p style={{width:'100%', textAlign:'center', paddingBottom:'35px', fontSize:'clamp(0.7rem, 1vw, 1rem)'}}>
                    NOB 4.0 S.r.l. - Società Benefit. &copy; Copyright 2023 - Sede in Via Appiani 12 - 20121 Milano - P.I. 04545490403
                  </p>          
                }        
            </div>                        
          </div>
        </Grid>
    </Grid>
    </>
  )
}